var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeNegative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1396 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 18,
    height: 16,
    transform: "translate(1396 411)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1396 411.653)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M231.147,160.065l2.466,2.466.012-.129a2.351,2.351,0,0,0-2.349-2.349Z",
    transform: "translate(-222.664 -155.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M152.775,66.011a3.916,3.916,0,0,1,3.915,3.915,3.854,3.854,0,0,1-.278,1.429l2.29,2.29a9.3,9.3,0,0,0,2.689-3.719,9.265,9.265,0,0,0-8.616-5.872,9.156,9.156,0,0,0-3.12.548l1.691,1.687A3.934,3.934,0,0,1,152.775,66.011Z",
    transform: "translate(-144.163 -62.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M.783,33.051l1.785,1.785.356.356A9.273,9.273,0,0,0,0,39.1a9.249,9.249,0,0,0,12.045,5.21l.333.333,2.282,2.286,1-.994L1.781,32.053Zm4.33,4.326,1.21,1.21a2.481,2.481,0,0,0-.059.513,2.351,2.351,0,0,0,2.349,2.349,2.413,2.413,0,0,0,.509-.059l1.21,1.21a3.851,3.851,0,0,1-1.719.415,3.889,3.889,0,0,1-3.5-5.637Z",
    transform: "translate(0 -32.053)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeNegative);
export default __webpack_public_path__ + "static/media/eye-negative.cdfd21e17f2244673fe196c768a999cd.svg";
export { ForwardRef as ReactComponent };